function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { CarrierLogisticsWebServerClientConfigFactory } from "@amzn/coral-config_carrier-logistics-web-server";
import { CoralClientFactory, CoralFetchHandler, InterceptingHandler } from "@amzn/ihm-js-coral-client";
import { carrierLogisticsWebServerHttpBindingInterceptor, CarrierLogisticsWebServer } from "@amzn/coral_com-amazon-carrierlogisticswebserver-model";
import RequestOptionsInterceptor from "./RequestOptionsInterceptor";
import envHelper from "../config/env";
var clientFactory = new CoralClientFactory([
    CarrierLogisticsWebServerClientConfigFactory
], envHelper.getEnv(), new InterceptingHandler(new CoralFetchHandler(), [
    carrierLogisticsWebServerHttpBindingInterceptor,
    new RequestOptionsInterceptor()
]));
/**
 * Custom web server to override serialization/deserialization
 */ var CustomWebServer = /*#__PURE__*/ function(CarrierLogisticsWebServer1) {
    "use strict";
    _inherits(CustomWebServer, CarrierLogisticsWebServer1);
    var _super = _create_super(CustomWebServer);
    function CustomWebServer(config, handler) {
        _class_call_check(this, CustomWebServer);
        return _super.call(this, config, handler);
    }
    return CustomWebServer;
}(CarrierLogisticsWebServer);
var CarrierLogisticsWebServerClient = clientFactory.get(CustomWebServer);
export default CarrierLogisticsWebServerClient;

//# sourceMappingURL=CarrierLogisticsWebServerClient.js.map